import { render, staticRenderFns } from "./CompanyBilling.vue?vue&type=template&id=847a883a&scoped=true&"
import script from "./CompanyBilling.vue?vue&type=script&lang=js&"
export * from "./CompanyBilling.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBilling.vue?vue&type=style&index=0&id=847a883a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847a883a",
  null
  
)

export default component.exports